import { ca } from '@cian/analytics';

import { IFavoriteEntity } from '../../types/results';
import { EOfferType } from '../../utils/trackings';

export const trackJoinTradeClick = (entity: IFavoriteEntity) => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Phones_Rosimuschestvo_popup_click',
    category: 'ListingFavorites',
    products: [
      {
        id: entity.entityId,
        offerType: EOfferType.Offer,
      },
    ],
  });
};

export const trackShowTradingWidgetModalClick = (entity: IFavoriteEntity) => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Open_listing_rosimuschestvo',
    category: 'Phones',
    products: [
      {
        id: entity.entityId,
        offerType: EOfferType.Offer,
      },
    ],
  });
};
